module.exports = __webpack_public_path__ + "img/bg3.941c8a3a.jpg";